import React from 'react';
import { motion } from 'framer-motion';
import { InteriorSlide } from './SlideShell';
import type { SlideProps } from './SlideShell';
const CUSTOMER_JOURNEY_EXAMPLES = 'https://cdn.magicpatterns.com/uploads/j9MzYRPzwKpSyc6y7h75ar/Screenshot_2026-09-11_at_11.48.05.png';
export function SlideCustomerJourneyExamples({}: SlideProps) {
  return <InteriorSlide surface data-id="element-350" data-mp="ivylvhwodps8">
      <motion.header initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="mb-[clamp(1rem,1.8vw,1.75rem)] flex flex-shrink-0 items-end justify-between gap-8" data-id="element-351" data-mp="16lasca0mbjqu">
        <div data-id="element-352" data-mp="wuolp5avq3ka">
          <p className="mb-2 text-[clamp(0.7rem,1vw,0.9rem)] font-bold uppercase tracking-[0.2em] text-[var(--brand)]" data-id="element-353" data-mp="wv7qrlffkxgw">
            Experience portfolio
          </p>
          <h2 className="text-[clamp(2rem,3.4vw,3.3rem)] font-extrabold leading-tight tracking-[-0.04em] text-[var(--fg)]" data-id="element-354" data-mp="1pjvkm5e8wv62">
            Snaks throughout the{' '}
            <span className="text-[var(--brand)]" data-id="element-355" data-mp="2c8c44j574bli">customer journey</span>
          </h2>
        </div>
        <p className="hidden max-w-sm text-right text-sm leading-relaxed text-[var(--muted)] lg:block" data-id="element-356" data-mp="2797x9z5qupyc">
          Real examples spanning awareness, education, interaction, engagement
          and insight generation.
        </p>
      </motion.header>

      <motion.figure initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.18,
      duration: 0.65
    }} className="flex min-h-0 flex-1 items-center justify-center overflow-hidden rounded-3xl border border-[var(--brand)]/10 bg-white p-3 shadow-sm" data-id="element-357" data-mp="2g94g3k5gculh">
        <img src={CUSTOMER_JOURNEY_EXAMPLES} alt="Examples of Snak experiences used throughout the customer journey" className="h-full w-auto object-contain" data-id="element-358" data-mp="33ypacz723ea2" />
      </motion.figure>
    </InteriorSlide>;
}